'use client'

import { useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import FortoSolutionImg from '@public/images/forto-case-study/forto-solution.png'
import PlaceHolder from '@public/images/placeholders/placeholder485x560.png'
import Image from 'next/image'
import { FC } from 'react'

import Link from '@/components/Link'
import OverflowImage from '@/components/OverflowImage'
import TitleAndParagraph from '@/components/TitleAndParagraph'
import TwoColumnLayout, { ColumnWrapOrder } from '@/components/TwoColumnLayout'

const FortoSolution: FC<{}> = () => {
    const { smScreen } = useDevice()

    return (
        <Box
            sx={{
                position: 'relative',
            }}
        >
            <TwoColumnLayout
                leftCol={5}
                rightCol={6}
                columnWrapOrderOnMobile={ColumnWrapOrder.REVERSE}
            >
                <OverflowImage
                    float={`right`}
                    containerSx={{
                        ...(smScreen
                            ? {
                                  height: '400px !important',
                              }
                            : {}),
                    }}
                    placeholder={
                        <Image
                            width={485}
                            height={560}
                            src={PlaceHolder}
                            alt={'placeholder'}
                            style={{
                                opacity: 0,
                                ...(smScreen
                                    ? {
                                          height: '400px',
                                      }
                                    : {}),
                            }}
                        />
                    }
                >
                    <Image
                        width={860}
                        height={560}
                        src={FortoSolutionImg}
                        alt={'Forto Dashboard'}
                        style={{
                            ...(smScreen
                                ? {
                                      height: '100%',
                                      objectFit: 'scale-down',
                                      objectPosition: 'right',
                                  }
                                : {}),
                        }}
                    />
                </OverflowImage>
                <TitleAndParagraph
                    title={`Solution`}
                    paragraph={
                        <span>
                            To accelerate its goal of becoming a green leader, Forto set out four
                            clear requirements for a solution: it had to be reliable, transparent,
                            credible, and flexible.
                            <br />
                            <br />
                            Lune fulfilled all four. Forto chose Lune’s emissions intelligence API
                            to calculate shipment-level emissions across all modes. Lune’s
                            transparent calculation logic and accredited methodology gave Forto the
                            confidence to integrate emission estimates into tenders and reporting
                            directly into their customer-facing platform.
                            <br />
                            <br />
                            Value creation didn’t stop there. Forto’s sustainability team continues
                            to work closely with Lune to develop innovative green solutions,{' '}
                            <Link
                                color="Grey900"
                                href="https://lune.co/blog/add-emission-estimates-to-shipping-tenders"
                                newPage
                                sx={{ textDecoration: 'underline' }}
                            >
                                such as the tender tool
                            </Link>
                            . Proving that ESG can create and maintain a competitive advantage.
                        </span>
                    }
                />
            </TwoColumnLayout>
        </Box>
    )
}

export default FortoSolution
